import React, {useState } from "react";  
import { Spinner, SpinnerSize } from "@fluentui/react";
import { 
    ArrowReset24Filled, 
    DocumentText24Filled, 
    Print24Filled, 
    TextBulletListSquareEdit24Filled,
    QrCode24Filled
 } from '@fluentui/react-icons';
import './styles.scss';
import RespondersList from '#root/components/RespondersList';
import { Responder } from '#root/queries/responders';
import { Button } from '@fluentui/react-components';
import { ROUTES } from "#root/routes/constants";
import { useNavigate } from "react-router-dom";
import { useBadgePrinting } from "#root/hooks/useBadgePrinting";
import QrScanner from '#root/components/QrScanner';  
import { showToast } from "#root/components/GlobalToaster";  

const CheckedInDeployable: React.FC = () => {
    const navigate = useNavigate();
    const { printBadges, isPrinting, printingIds } = useBadgePrinting();
    const [showQrScanner, setShowQrScanner] = useState(false);  

    const handlePrintBadge = (responder: Responder) => printBadges([responder.id]);
    const handlePrintSelectedBadges = (selectedResponderIds: string[]) => printBadges(selectedResponderIds);

    const handleRegenQR = (responder: Responder) => {
        console.log('Regenerate QR code for responder:', responder);
    };

    const handleChangeStatus = (responder: Responder) => {
        navigate(`${ROUTES.MERRGE211.CHANGE_STATUS}?responderId=${responder.id}`);
    };

    const handleRegenerateSelectedQrCodes = (selectedResponderIds: string[]) => {
        console.log('Regenerate QR codes for responders:', selectedResponderIds);
    };

    const handleQRCode = () => {  
        setShowQrScanner(true);  
    };  
    const handleQrScan = (url: string) => {  
        setShowQrScanner(false);  
        try {  
            const qrUrl = new URL(url);  
            qrUrl.searchParams.set('isQrScaned', 'true');  
            window.location.href = qrUrl.toString();
        } catch {  
            showToast('Incorrect QR code please try again', 'error');  
        }  
    };  

    const handleCloseQrScanner = () => {  
        setShowQrScanner(false);  
    };  

    const renderActions = (responder: Responder, onActionComplete?: () => void) => {
        const isPrintingThis = printingIds.includes(responder.id);
        return (
            <>
                <Button
                    icon={isPrintingThis ? <Spinner size={SpinnerSize.small} /> : <DocumentText24Filled />}
                    appearance="primary"
                    disabled={isPrinting}
                    onClick={() => {
                        handlePrintBadge(responder);
                        if (onActionComplete) onActionComplete();
                    }}
                >
                    {isPrintingThis ? "Printing..." : "Print Badge"}
                </Button>
                <Button
                    icon={<ArrowReset24Filled />}
                    appearance="secondary"
                    onClick={() => {
                        handleRegenQR(responder);
                        if (onActionComplete) onActionComplete();
                    }}
                >
                    Regen QR
                </Button>
                <Button
                    icon={<TextBulletListSquareEdit24Filled />}
                    appearance="primary"
                    className="button-green"
                    onClick={() => {
                        handleChangeStatus(responder);
                        if (onActionComplete) onActionComplete();
                    }}
                >
                    Change Status
                </Button>
            </>
        );
    };

    const renderFooterActions = (selectedResponderIds: string[], onActionComplete?: () => void) => {
        return (
            <>
                <Button
                    icon={<ArrowReset24Filled />}
                    appearance="primary"
                    onClick={() => {
                        handleRegenerateSelectedQrCodes(selectedResponderIds);
                        if (onActionComplete) onActionComplete();
                    }}
                >
                    Regenerate QR Codes
                </Button>
                <Button
                    icon={isPrinting ? <Spinner size={SpinnerSize.small} /> : <Print24Filled />}
                    appearance="primary"
                    disabled={isPrinting || selectedResponderIds.length === 0}
                    onClick={() => {
                        handlePrintSelectedBadges(selectedResponderIds);
                        if (onActionComplete) onActionComplete();
                    }}
                >
                    {isPrinting ? "Printing..." : "Print Selected Badges"}
                </Button>
            </>
        );
    };

return (  
        <>  
            <RespondersList  
                title="Checked In Responders"  
                className="checked-in-responders"  
                renderActions={renderActions}  
                renderFooterActions={renderFooterActions}  
                showDeploymentFields={true}  
                isDeployable={true}  
                titleButton={  
                    <Button appearance="primary"  
                            icon={<QrCode24Filled />}  
                            onClick={handleQRCode}>  
                        Scan QR Code  
                    </Button>  
                }  
            />  
            {showQrScanner &&  
                <QrScanner  
                    onScan={handleQrScan}  
                    onClose={handleCloseQrScanner}  
                />  
            }  
        </>  
    );  
};  
export default CheckedInDeployable;  